// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"PieGraphInd_mainWrapper__2WKiw","wrapper":"PieGraphInd_wrapper__2hbqC","porcent":"PieGraphInd_porcent__3TSbx"};